import { render, staticRenderFns } from "./ClvModalUsers.vue?vue&type=template&id=3b12dd14&"
import script from "./ClvModalUsers.vue?vue&type=script&lang=js&"
export * from "./ClvModalUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports